<template>
    <div class="form-items-wrapper">
        <template v-for="(item, idx) in config" >
            <template v-if="Array.isArray(item)" >
                <div
                    :key="'inlineItem' + idx"
                    class="form-item form-items"
                >
                    <template v-for="(iItem, index) in item">
                        <BaseItem 
                            v-if="iItem.renderable === false ? false : true"

                            :key="iItem.mold + '-' + (iItem.prop ? iItem.prop : (idx + '-' + index))"

                            :class="[
                                'form-item-inline',
                                `form-item-${iItem.mold}`,
                                {
                                    'form-item-link': iItem.link && ((Array.isArray(iItem.link) && iItem.link.some(link => link.mold)) || iItem.link.mold)
                                },
                                `form-item-${iItem.mold}-${iItem.prop ? iItem.prop : idx + '-' + index}`
                            ]"

                            :popper-class="popperClass"
                    
                            :item="iItem"

                            v-model="value"
                            :resets.sync="resets"
                            :disableds="disableds"

                            :loading="loading"

                            @after-leave="val => $emit('after-leave', val)"
                            @advance="val => $emit('advance', val)"
                            @query-click="$emit('query-click')"
                            @add-click="$emit('add-click')"
                            @other-click="$emit('other-click')"
                            @enter-click="$emit('enter-click')"
                        />
                    </template>
                </div>
            </template>

            <template v-else>
                <BaseItem 
                    v-if="item.renderable === false ? false : true"

                    :key="item.mold + '-' + (item.prop ? item.prop : idx)"

                    :class="[
                        'form-item',
                        `form-item-${item.mold}`,
                        {
                            'form-item-link': item.link && ((Array.isArray(item.link) && item.link.some(link => link.mold)) || item.link.mold)
                        },
                        `form-item-${item.mold}-${item.prop ? item.prop : idx}`
                    ]"
                    
                    :popper-class="popperClass"

                    :item="item"

                    v-model="value"
                    :resets.sync="resets"
                    :disableds="disableds"

                    :loading="loading"
                                
                    @after-leave="val => $emit('after-leave', val)"
                    @advance="val => $emit('advance', val)"
                    @query-click="$emit('query-click')"
                    @add-click="$emit('add-click')"
                    @other-click="$emit('other-click')"
                    @enter-click="$emit('enter-click')"
                />
            </template>
        </template>
    </div>
</template>

<script>

import BaseItem from "./Item";

export default {
  name: "FormCustomBaseList",

  components: {
    BaseItem
  },

  inheritAttrs: false,

  props: {
    config: {
      type: Array,
      default: () => ([])
    },

    loading: {
      default: false,
      type: Boolean
    },
    popperClass: {
      type: String,
      default: "" 
    },
    resets: {
      default: () => ({}),
      type: Object 
    },

    disableds: {
      default: () => ({}),
      type: Object 
    },

    value: {
      default: () => ({}),
      type: Object 
    }
  }
};
</script>

<style>

</style>
